import axios from '../../utils/axios'
import { API_BASE_URL } from '../../constants'

export const deletePacBioBamFile = async (pacbioBamId) => {
  const { data } = await axios.delete(`${API_BASE_URL}/pacbio/${pacbioBamId}`)
  return data
}
